module.exports = __webpack_public_path__ + "img/bars_select@2x.19bff2d0.svg";